<template>
    <div>
        <IconFamily />
        <p class="heading-2 heading-md-1 weight-medium mt-20">
            Application successfully submitted!
        </p>
        <p class="body-3 body-md-1 text-left weight-regular mt-10">
          We have e-mailed you a confirmation along with instructions and
          a link to download
          your completed application form.
        </p>
      <DownloadApplication v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0"
                           :path="model.saveResponse[index].docs.filter(doc => doc.name === 'uzp-prihlaska.pdf')[0].path"
                           :variableSymbol="model.saveResponse[index].cislo"
                           :person="person"
                           :key="index"/>
        <p class="heading-3 mt-20">
          What are the next steps?
        </p>
        <Card class="card-border-gray-300 p-10 mt-10 b-rounded-12">
            <div class="flex gap-6 w-full">
                <CircleNumber :value="1" />
                <p class="body-3 mt-2 mb-0 text-left">
                  We have e-mailed you a PDF of your signed application form, which you can save or print out.
                </p>
            </div>

            <div class="flex gap-6 mt-6 w-full">
                <CircleNumber :value="2" />
                <p class="body-3 mt-2 mb-0 text-left">
                  Once your qualified electronic signature has been verified, we will e-mail you to confirm the validity of your application.
                </p>
            </div>

            <div class="flex gap-6 mt-6 w-full">
                <CircleNumber :value="3" />
                <p class="body-3 mt-2 mb-0 text-left">
                  Please wait for your new health insurance card to be issued, and don't forget to check out the
                  <a class="color-primary" target="_blank" href="https://www.union.sk/vyhody-pre-poistencov/">
                    wide range of benefits we offer.
                  </a>
                </p>
            </div>
        </Card>
        <h3 class="mt-20">
          Thank you for being with us.
        </h3>
        <Rating :model="model"/>
        <div class="width-md mt-20">
            <Button v-if="showReturnHomeButton" @click="reload" class="btn-primary w-full" :icon-right="require('@/assets/svg/icon-right-white.svg')">
              Go to Main Page
            </Button>
        </div>
    </div>
</template>

<script>
import IconFamily from '@/components/Icons/IconFamily.vue';
import CircleNumber from '@/components/CircleNumber/CircleNumber.vue';
import Card from '@/components/Card/Card.vue';
import Button from '@/components/Button/Button.vue';
import { setHashChannelParams } from '@/utils/urlParams';
import url from '@/mixins/url';
import Rating from '@/components/Rating/Rating.vue';
import DownloadApplication from '@/components/DownloadApplication/DownloadApplication.vue';

export default {
  name: 'EidSuccess',
  components: {
    DownloadApplication,
    Rating,
    IconFamily,
    CircleNumber,
    Card,
    Button,
  },
  mixins: [url],
  props: {
    model: { required: true, type: Object },
  },
  methods: {
    reload() {
      const { hash, channel } = this.$route.query;
      const otherParams = setHashChannelParams(hash, channel);
      window.location.replace(`${window.location.origin + window.location.pathname}#landing-page${otherParams}`);
      window.location.reload();
    },
  },
};
</script>
